import React from "react";
import {
  Box,
  Checkbox,
  CheckboxProps,
  FormControlLabel,
  Tooltip,
} from "@material-ui/core";
import clsx from "clsx";
import { useSelector } from "react-redux";
import { AppState } from "../../redux";
import { StyleProps, useCheckboxStyles } from "../layout/sharedCheckboxStyles";

/**
 * Props for a checkbox component that works independently from Formik.
 */
interface CustomCheckboxStandaloneProps extends CheckboxProps {
  label?: string | React.ReactNode;
  small?: boolean;
  tooltipText?: string;
}

/**
 * Checkbox component that handles all behavior without relying on Formik wrappers.
 */
const CustomCheckboxWithoutFormik: React.FC<CustomCheckboxStandaloneProps> = ({
  label,
  small,
  tooltipText,
  ...props
}) => {
  const accessibility = useSelector((state: AppState) => state.accessibility);
  const monoMode = accessibility.monoMode;

  const classes = useCheckboxStyles({
    monoMode,
    disabled: props.disabled,
  } as StyleProps);

  const [focused, setFocused] = React.useState(false);

  return (
    <FormControlLabel
      style={{ margin: 0 }}
      className={small ? classes.small : classes.large}
      control={
        <Tooltip
          title={tooltipText || ""}
          // only show tooltip when a text is provided
          disableHoverListener={!tooltipText}
          arrow
        >
          <Box>
            <Checkbox
              {...props}
              onFocus={(e) => {
                setFocused(true);
                props.onFocus?.(e);
              }}
              onBlur={(e) => {
                setFocused(false);
                props.onBlur?.(e);
              }}
              color="default"
              className={focused ? (monoMode ? "focused-mono" : "focused") : ""}
              checkedIcon={
                <span className={clsx(classes.icon, classes.checkedIcon)} />
              }
              icon={<span className={classes.icon} />}
              inputProps={{ "aria-label": "checkbox" }}
            />
          </Box>
        </Tooltip>
      }
      label={label ? <Box style={{ marginLeft: "1.25rem" }}>{label}</Box> : ""}
    />
  );
};

export default CustomCheckboxWithoutFormik;
